module.exports = kolibriCoreAppGlobal.resources;